import vlenergy from "../../assets/VLEnergy-Logo-Black.png"
import "./Header.scss";

const Header = ()=> {
    return (
        <div className="header">
            <div className="header__wrapper">
                <div className="header__content">
                    <img className="header__img" src={vlenergy} alt="VL Energy" />
                    <h4 className="header__text"><a href="https://vlenergy.ca/">Home</a></h4>
                </div>
                
            </div>
        </div>
    );
}

export default Header;